module.exports = __webpack_public_path__ + "2efddc58a5dd1ec4da6dc44e03859f54.pdf";